// Korean language file
export const KO = {
  preparing_zip: "압축 파일 준비 중…",
  compressing: "압축 중…",
  info_icon: "완료로 표시되면 추가 멤버는 참여하거나 추가할 수 없으며 모든 채팅 그룹이 비활성화됩니다. 프로젝트는 모든 채팅 그룹 및 데이터와 함께 비활성화된 상태로 액세스 가능하게 유지됩니다.",
  mark_is_done: "프로젝트를 완료로 표시하시겠습니까? 표시되면 추가 멤버는 참여하거나 추가할 수 없으며 모든 채팅 그룹이 비활성화됩니다. 프로젝트는 모든 채팅 그룹 및 데이터와 함께 비활성화된 상태로 액세스 가능하게 유지됩니다.",
  mark_not_done: "프로젝트를 다시 열겠습니까? 열림으로 표시되면 추가 멤버가 참여하거나 추가할 수 있으며 모든 채팅 그룹이 다시 활성화됩니다.",
  mark_as_completed: "프로젝트를 완료로 표시",
  room_completed: "프로젝트 완료",
  room_members: "프로젝트 멤버",
  deactivated_rooms: "비활성화된 프로젝트",
  deactivated_chats: "비활성화된 채팅",
  completed_rooms: "완료된 프로젝트",
  request_to_join_a_room: '프로젝트 참여 요청',
  wants_to_rejoin_room: 'Username님이 Roomname 프로젝트에 다시 참여하기를 원합니다.',
  invited_you_to_join_room: 'Username님이 Roomname 프로젝트에 참여하도록 초대했습니다.',
  restart: "다시 시작",
  update_text: "새 업데이트를 사용할 수 있습니다. 다시 시작을 클릭하여 업데이트를 설치하세요.",
  update_availble: "업데이트 사용 가능",
  Loading: "로딩 중...",
  logout: "로그아웃",
  back: '뒤로',
  company_list: "회사 목록",
  followers: "팔로워",
  followings: "팔로잉",
  article: "기사",
  companies: "회사",
  one_to_one_chat: " 1대1 채팅",
  profile: "프로필",
  company: "회사",
  company_selection: "회사 선택",
  home: "홈",
  contact: "연락처 ",
  add_company: "회사 추가 ",
  add_project: "프로젝트 추가 ",
  capacities: "역량 ",
  work_area: "작업 영역",
  company_services: "회사 서비스",
  website: "웹사이트",
  search_contacts: "연락처 검색",
  add_or_join_a_company: "회사 추가 또는 참여",
  follow: "팔로우",
  following: "팔로잉 중",
  like: "좋아요",
  company_contacts: "회사 연락처",
  leave_the_company: "회사 떠나기",
  news: "뉴스",
  earlier: "이전",
  action: "작업",
  another_action: "다른 작업",
  something_else: "기타",
  search: "검색",
  search_rooms: "프로젝트 검색",
  search_articles: "기사 검색",
  contacts: "연락처",
  suggestions: "제안",
  project_list: "프로젝트 목록",
  search_results: "검색 결과",
  add_or_join_project: "프로젝트 추가 또는 참여",
  details: "세부 정보",
  your_position_within_company: "회사 내에서의 직책을 선택하세요.",
  close_modal: "닫기",
  map: "지도",
  or: "또는",
  name: "이름*",
  street: "거리*",
  house_number: "집 번호",
  postal_code: "우편번호",
  city: "도시*",
  opened_by: "개설자:",
  project_No: "프로젝트 번호: ",
  building_type: "건물 유형*",
  building_types: "건물 유형",
  add_join: "추가/참여",
  mandatory_fiels: "*필수 항목",
  invalid_fiels: "이 필드는 필수입니다",
  add_or_join_company: "회사 추가 또는 참여",
  name_of_the_company: "회사명",
  edit_company_details: "회사 세부 정보 편집",
  branch_of_the_building_industry: "건설 산업 분야",
  corporate_form: "법인 형태",
  position_within_company: "회사 내 직책",
  request_confirmation: "대기 중인 프로젝트 요청",
  company_e_mail: "회사 이메일",
  type_of_filter: "필터 입력...",
  setting: "설정",
  dashboard: "대시보드",
  settings: "설정",
  views: "조회수",
  times_seen: "회 조회",
  see_more: "...더 보기",
  see_less: "...접기",
  in_search: "검색에서",
  reset_password: "비밀번호 재설정",
  submit: "제출",
  password: "비밀번호",
  email: "이메일",
  confirm_password: "비밀번호 확인",
  reset_email: "이메일 재설정",
  update: "업데이트",
  new_email: "새 이메일",
  kjuup_message: "Kjuup 메시지",
  delete_profile: "프로필 삭제하시겠습니까?",
  my_position: "내 직책:",
  add: "추가",
  owner_company_admin: "회사 관리자:",
  owner_company_admin_new: "회사 관리자",
  mutual_contact: "공통 연락처",
  mutual_contacts: "공통 연락처",
  co_owner: "공동 소유자",
  managing_director: "경영 이사",
  associate: "협력자",
  secretary: "비서",
  employee: "직원",
  project_manage: "프로젝트 매니저",
  auto_chat_translation: "자동 채팅 번역",
  translate_room_group_names: "채팅 그룹 이름 번역",
  translate_room_group_names_info: "사용 설정하면 채팅 그룹 이름이 인터페이스 언어로 자동 번역됩니다.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "활성화하면 앱을 열 때 메시지 대신 이메일 탭이 기본으로 열립니다.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "언어",
  english: "영어",
  german: "독일어",
  french: "프랑스어",
  italian: "이탈리아어",
  change_language: "언어 변경",
  my_companies: "내 회사",
  employees: "직원",
  invite_with_a: "Kjuup에 초대",
  add_member: "멤버 추가",
  add_user: "사용자 추가",
  send_location: "위치 보내기",
  assign_admin_rights: "관리자 권한 조정",
  deactivate_company: "회사 비활성화",
  remove_employees: "직원 제거",
  remove_members: "멤버 제거",
  no_user_found: "사용자를 찾을 수 없습니다!",
  approve: "승인!",
  deselect_all: "모두 선택 해제",
  select_all: "모두 선택",
  translation_on_building_projects: "프로젝트에서의 번역",
  reported_capacities: "보고된 서비스",
  up_to_50m_exact: "최대 50m 정확",
  company_details_service: "회사 서비스",
  company_contact: "회사 연락처",
  invite_with_link: "Kjuup에 초대",
  share_link: "링크 공유",
  share_company_link: "링크 공유",
  qr_code: "QR 코드",
  copy_link: "링크 복사",
  cancel_link: "링크 취소",
  who_has_confirmed_services: "누가 귀하의 서비스를 확인했습니까?",
  projectss: "프로젝트",
  add_services: "서비스 추가",
  services: "서비스",
  save_text: "저장",
  share_on: "공유 대상:",
  articlen: "기사",
  invite_user_to_confirm_service: "사용자를 초대하여 회사의 서비스를 확인하세요.",
  link_copied: "링크가 복사되었습니다!",
  email_copied: "이메일이 복사되었습니다!",
  personal_article: "개인 기사",
  company_article: "회사 기사",
  characters_remaining: "남은 문자",
  optional_information: "선택 정보",
  project: "프로젝트",
  projects: "프로젝트...",
  abort: "취소",
  preview: "미리보기",
  post: "게시",
  of: "의",
  remove: "제거",
  free_capacity: "구인 포털",
  current_status_overview: "현재 상태 개요",
  report_capacities: "서비스 보고",
  report_text: "보고",
  search_capacities: "계약자 찾기",
  add_project_user: "프로젝트 사용자 추가",
  media: "미디어",
  links: "링크",
  docs: "문서",
  featured_products: "추천 제품...",
  title: "제목",
  text: "텍스트",
  feed_details: "피드 세부 정보",
  add_employee: "직원 추가",
  latest: "최신",
  my_projects: "내 프로젝트",
  cancel: "취소",
  continue: "계속",
  role_in_the_building_industry: "건설 산업에서의 역할",
  als: "로",
  join: "참여",
  find: "찾기",
  request_to_join_a_company: "회사 참여 요청",
  wants_to_join_the_company: "회사에 참여하고 싶습니다",
  filter_by: "필터",
  ok: "확인",
  close: "닫기",
  weekly_statistics: "주간 통계",
  is_following_you: "이(가) 당신을 팔로우하고 있습니다.",
  as: "로",
  has_joined_the: "이(가) 회사에 참여했습니다",
  has_looked_at_your_profile: "이(가) 귀하의 프로필을 확인했습니다.",
  time: "시간",
  in_searches_in_past_week: "지난 주 검색에서.",
  has_liked_your_article: "이(가) 귀하의 기사에 좋아요를 눌렀습니다.",
  has_published_a_new_article: "이(가) 새 기사를 게시했습니다.",
  you: "당신",
  all_views: "모든 조회",
  all_profile_views: "모든 프로필 조회",
  mutual_company: "공통 회사",
  artical_text: "기사 작성...",
  you_have_appeared: "표시되었습니다",
  your_request_at_the_company: "회사에서의 요청",
  times_you_have_appeared_in_searches: "회 검색에 표시되었습니다",
  appear_more_often_in_searches: "검색에서 더 자주 표시되기",
  you_have_been_found: "찾았습니다",
  improve_profile: "프로필 개선",
  choose_existing_contact_for_single_chat: "1대1 채팅을 위한 기존 연락처 선택:",
  in_order_to_add_new_contacts: "새 연락처를 추가하려면 프로필 페이지에서 새 연락처를 검색하세요.",
  times_in_searches_in_the_last_week: "지난 주 검색에서 회. 프로필을 업데이트하고 더 쉽게 찾을 수 있도록 세부 정보를 추가하세요.",
  has_been_confirmed: "이(가) 확인되었습니다.",
  have_joined_the: "이(가) 참여했습니다 ",
  building_project: " 건설 프로젝트.",
  select_with_which_company_you_want_to_connect_to_the_project: "대표할 회사를 선택하세요. 이것은 다른 참가자에게 표시됩니다.",
  select_with_which_company_you_want_to_connect_to_the_chat: "대표할 회사를 선택하세요. 이것은 다른 참가자에게 표시됩니다.",
  select_internal_section: "내부 섹션을 선택하세요",
  select_profile_image: "프로필 이미지 선택",
  share_user: "사용자 공유",
  contact_sender_message: "이 링크를 공유하여 Kjuup의 비회원을 Kjuup에 초대하세요. 이 링크는 여러 사람이 등록하는 데 사용할 수 있습니다.",
  project_sender_message: "이 링크를 공유하여 Kjuup의 비회원을 프로젝트 “프로젝트 이름”에 초대하세요. 이 링크는 여러 사람이 등록하고 Kjuup의 프로젝트 “프로젝트 이름”에 참여하는 데 사용할 수 있습니다.",
  company_sender_message: "이 링크를 공유하여 Kjuup의 비회원을 회사 회사 이름에 초대하세요. 이 링크는 여러 사람이 등록하고 Kjuup의 회사에 참여하는 데 사용할 수 있습니다.",
  contact_receivers_message: "Kjuup에 참여하는 초대 링크. kjuup에 등록하려면 링크를 클릭하세요.",
  iphone: "iPhone:",
  iphone_recivers_message: "Apple App Store를 통해 Kjuup을 설치하는 경우 등록할 수 있도록 성공적으로 다운로드한 후 이 링크를 클릭해야 합니다.",
  project_receivers_message: "Kjuup의 프로젝트 “프로젝트 이름”에 참여하는 초대 링크. Kjuup에 등록하고 프로젝트 “프로젝트 이름”에 참여하려면 링크를 클릭하세요.",
  company_receivers_message: "Kjuup의 회사 회사 이름에 대한 초대 링크. Kjuup에 등록하고 회사 회사 이름에 참여하려면 링크를 클릭하세요.",
  sign_in: "로그인",
  enter_your_email_add: "이메일 주소를 입력하세요",
  forgot_password: "비밀번호를 잊으셨나요",
  dont_have_account: "계정이 없으신가요?",
  register: "등록",
  get_app: "앱 받기",
  registration: "등록",
  dep_ing: "Dipl.-Ing.",
  dr: "박사",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architect",
  prof: "교수",
  first_name: "이름",
  last_name: "성",
  have_an_account: "계정이 있으신가요?",
  when_register_you_agree: "등록 시 다음에 동의합니다",
  term_of_use: "이용 약관",
  to: "에.",
  in_our: "우리의",
  data_policy: "데이터 정책",
  they_find_out: "그들이 알아내는,",
  we_provide_store_data: "정보를 수집, 처리 및 저장하는 방법.",
  leaving_company_text: "정말로 회사를 떠나시겠습니까? 회사를 떠나면 관련된 모든 프로젝트와 채팅 그룹도 떠나게 됩니다. 언제든지 다른 회사로 이러한 프로젝트에 다시 참여할 수 있습니다.",
  delete_profile_text: "정말로 프로필을 삭제하시겠습니까? 프로필을 삭제하면 회사, 프로젝트 및 채팅에 대한 모든 연결이 제거됩니다. 언제든지 새 프로필을 만들 수 있습니다.",
  confirm: "확인",
  reject: "거부",
  requet_to_leave: "떠나기 요청",
  choose: "선택",
  your_add_member: "멤버 추가",
  if_you: "만약",
  can_not_find: "여기서 연락처를 찾을 수 없습니다.",
  please_wait: "잠시 기다려주세요..",
  imprint_gtc: "인쇄물/이용약관",
  register_confirm_popup: "로그인하기 전에 Kjuup 이메일을 인증해 주세요. 확인 링크를 보내드렸습니다. 보이지 않으면 스팸 폴더도 확인해 주세요.",
  PENDING_GROUP_USER: "프로젝트 초대가 확인된 후에만 메시지를 받게 됩니다. 프로젝트 초대가 확인되면 추가 메시지가 나타납니다.",
  PENDING: "프로젝트 초대 확인 대기 중",
  denied_group_chat: " 이(가) 프로젝트 초대를 거부하고 이 그룹을 떠났습니다.",
  joined_group_chat: " 이(가) 이 그룹에 참여했습니다",
  you_joined_group_chat: "이 그룹에 참여했습니다.",
  Others: "기타",
  LEFT_GROUP: "이(가) 이 채팅 그룹을 떠났습니다.",
  YOU_LEFT_GROUP: "이(가) 이 채팅 그룹을 떠났습니다.",
  days: "일",
  day: "일",
  hour: "시간",
  hide_project: "프로젝트 숨기기",
  hide_project_popup_text: "프로젝트를 숨기면 Kjuup 내에서 찾을 수 없습니다. 프로젝트의 멤버만 새 사용자를 프로젝트에 초대할 수 있습니다.",
  branch: "분야",
  photo_video_media_lib: "사진 - 비디오 미디어 라이브러리",
  document: "문서",
  location_meeting: "위치 / 회의",
  all_member_of_project: "프로젝트의 모든 멤버",
  pending_request: "대기 중인 프로젝트 요청",
  no_pending_request: "대기 중인 요청을 찾을 수 없습니다!",
  news_feed: "뉴스 피드",
  user_info: "그룹 정보",
  leave_project: "프로젝트 떠나기",
  media_link_docs: "파일",
  search_chat: "채팅 검색",
  export_chat_group: "지난 달 채팅 그룹 데이터 내보내기",
  request_complete_chat_history: "전체 채팅 기록 요청",
  leave_chat_group: "채팅 그룹 떠나기",
  add_user_project: "사용자 추가",
  me: "나",
  max_open_one_to_one: "현재 최대 2개의 1대1 채팅을 하단 및 상단 섹션에서 병렬로 열 수 있습니다. 총 최대 4개의 1대1 채팅이 가능합니다.",
  are_you_sure_you_want_leave_chat: "정말로 이 채팅 그룹을 떠나시겠습니까?",
  create_group: "그룹 만들기",
  adding_members: "멤버 추가 중...",
  creating_the_chat: "채팅 생성 중...",
  finishing_setup: "설정 완료 중...",
  group_name: "그룹 이름",
  by: "작성자:",
  mandetory: "*필수",
  delteed: "이(가) 프로필을 삭제하고 그룹 채팅을 떠났습니다.",
  deleted_direct: "이(가) 프로필을 삭제하고 채팅을 떠났습니다.",
  unhidden_message: "프로젝트 숨기기를 해제하면 Kjuup의 모든 멤버가 찾을 수 있습니다.",
  account_deleted: "계정이 삭제되었습니다.",
  refuse_company: "정말로 회사 초대를 거부하시겠습니까?",
  follow_additional: "추가 사용자 팔로우",
  f_add: "Kjuup의 추가 사용자를 팔로우하여 직접 메시지에 사용할 수 있도록 하세요.",
  c_inv: "회사 초대",
  invited_o_Company: "회사에 참여하도록 초대되었습니다",
  refuse_companyX: "정말로 회사 요청을 거부하시겠습니까?",
  a_Da: "계정이 비활성화되었습니다.",
  has_deactivated: "이(가) 프로필을 비활성화했습니다.",
  reactive: "이(가) 프로필을 다시 활성화했습니다.",
  juup_note: "*사용자 이름으로 등록은 Kjuup+ 멤버만 사용 가능",
  username: "사용자 이름*",
  email_username: "이메일/사용자 이름*",
  sPinText: "6자리 보안 PIN을 제공하세요. 이 PIN은 비밀번호를 잊은 경우 필요하며 계정을 확인하는 데 필수입니다.",
  DeleteKjuupPlusText: "정말로 프로필을 삭제하시겠습니까? 프로필을 삭제하면 회사, 프로젝트 및 채팅에 대한 모든 연결이 제거됩니다.\n\n계정 삭제 후 48시간 이내에 사용자 이름, 비밀번호 및 PIN으로 로그인하여 계정을 다시 활성화할 수 있습니다.",
  reactive_text: "계정이 삭제되었습니다. 다시 활성화를 클릭하여 계정을 다시 활성화하세요.",
  rac: "다시 활성화",
  ac_ss: "계정이 성공적으로 다시 활성화되었습니다.",
  not_valid_pin: "PIN이 유효하지 않음",
  only_for_kjuup: "*사용자 이름 및 PIN을 통한 비밀번호 재설정은 Kjuup+ 멤버만 사용 가능합니다.",
  resetPIN: "PIN 재설정",
  enter_current_pin: "현재 PIN을 입력하세요",
  enter_new: "새 PIN 입력",
  pin_to_confirm: "확인을 위해 PIN을 제공하세요.",
  change_username: "사용자 이름 재설정",
  pp_not_match: "비밀번호와 확인 비밀번호가 일치하지 않습니다",
  reactive_itself: "프로필을 다시 활성화했습니다.",
  has_deactivated_itself: "프로필을 비활성화했습니다.",
  more_than_two: "현재 직접 메시지는 2명의 사용자와 병렬로만 가능합니다.",
  Chats: "직접 메시지",
  only_in_mobileL: "네이티브 비디오는 현재 모바일 앱을 통해서만 업로드 및 게시할 수 있습니다. Youtube 및 Vimeo의 비디오 링크를 사용하세요.",
  register_pin_text: "개인 6자리 PIN을 선택하세요. 이 PIN은 계정 재설정 기능을 활성화하는 데 필요합니다.",
  internal_project: "내부",
  external_projects: "외부",
  in_deacticted: "내부 섹션이 비활성화되었습니다.",
  create_article: "기사 작성",
  new_article_selection: "외부 뉴스 피드용 기사 작성",
  new_article_selection_internal: "사내 기사 작성",
  active_trans_title: "자동 번역을 켜시겠습니까?",
  active_trans: "활성화하면 모든 수신 채팅 메시지가 선택한 앱 언어로 번역됩니다.",
  disable_trans: "정말로 자동 번역을 비활성화하시겠습니까?",
  allow_access_chat: "전체 채팅 기록 표시",
  toggle_chat_history_on: "정말로 사용자에게 전체 채팅 기록을 보여주시겠습니까?",
  toggle_chat_history_off: "정말로 사용자에게 채팅 참여 시점부터의 채팅 기록만 보여주시겠습니까?",
  check_selected_settings: "선택한 모든 사용자의 채팅 기록 설정을 확인하세요!",
  chat_from_start_have: "이 그룹에 참여했습니다. 채팅 기록이 공유되었습니다.",
  chat_from_start_has: "이(가) 이 그룹에 참여했습니다. 채팅 기록이 공유되었습니다.",
  Address: "주소",
  read_by: "읽은 사람",
  deliver_to: "전달 대상",
  remaining: "남음",
  message_info: "메시지 정보",
  request_to_join_only: "참여 요청",
  unfollow: "팔로우 취소",
  company_username: "사용자 이름",
  month: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
  remove_my_admin_right: "내 관리자 권한 제거",
  makeEmp: "정말로 사용자로부터 회사 관리자 권한을 제거하시겠습니까?",
  remove_my_self: "정말로 계정에서 회사 관리자 권한을 제거하시겠습니까?",
  makeAdmin: "정말로 사용자에게 회사 관리자 권한을 부여하시겠습니까?",
  remove_member: "멤버 제거",
  remove_following_confirm: "정말로 {name}을(를) 팔로우 목록에서 제거하시겠습니까?",
  remove_follower_confirm: "정말로 {name}을(를) 팔로워 목록에서 제거하시겠습니까? 제거하면 해당 사용자에게 알림이 가지 않습니다.",
  do_you_really_want_to_remove: "정말로 회사에서 사용자 이름을 제거하시겠습니까?",
  invite_all: "회사의 모든 멤버 초대",
  invite_all_members: "모든 멤버 초대",
  mems: "다른 모든 멤버",
  dep_loc: "부서/위치/팀",
  depAdmin: "부서 관리자",
  add_remove_admin: "회사 관리자 직책 추가/제거",
  add_remove_dep_admin: "부서 관리자 직책 추가/제거",
  remove_employees_dept: "에서 직원 제거",
  want_to_join_dep: "사용자 이름이 회사 companyname의 부서/위치/팀 depname에 참여하고 싶습니다.",
  you_invited: "회사 companyname의 부서/위치/팀 depname에 참여하도록 초대되었습니다.",
  dep_remove: "정말로 사용자로부터 부서 또는 위치의 관리자 권한을 제거하시겠습니까?",
  add_dep: "정말로 사용자에게 부서 또는 위치의 관리자 권한을 부여하시겠습니까?",
  my_self_dep_remove: "정말로 계정에서 부서 관리자 권한을 제거하시겠습니까?",
  member: "멤버",
  admin: "관리자",
  remove_project_admin: "정말로 프로젝트에서 멤버를 제거하시겠습니까?",
  remove_my_self_project: "정말로 관리자 권한을 제거하시겠습니까?",
  remove_member_admin_right: "정말로 사용자로부터 관리자 권한을 제거하시겠습니까?",
  add_member_admin_right: "정말로 사용자에게 관리자 권한을 추가하시겠습니까?",
  add_remove_Poss: "관리자 직책 추가/제거",
  forward: "전달",
  edit: "편집",
  only_kjuup_plus_can: "Kjuup+ 회사만 기사를 게시할 수 있습니다.",
  add_images: "이미지 추가",
  request_confirmation: '대기 중인 프로젝트 초대',
  Activity: "활동",
  latest_messages: "최신 메시지",
  hours: "시간",
  minute: "분",
  seconds: "초",
  days: "일",
  yesterday: "어제",
  last_week: "지난 주",
  next_week: "다음 주",
  Last_month: "지난 달",
  All: "모두",
  register_plus: "등록 플러스",
  select_files: "파일 선택",
  monthsFullName: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
  company_deploc_receivers_message: "Kjuup의 회사 company name 부서에 대한 초대 링크. Kjuup에 등록하고 회사 company name에 참여하려면 링크를 클릭하세요.",
  no_news: "뉴스 없음",
  reminder: "알림",
  np_reminder: "ToDo 없음",
  move_to_reminder: "ToDo로 이동",
  remove_reminder: "정말로 이 메시지를 ToDo 목록에서 제거하시겠습니까?",
  remove_all_reminder: "모든 ToDo 제거",
  remove_all_confirm: "정말로 모든 메시지를 ToDo 목록에서 제거하시겠습니까?",
  remove_from_reminder: "알림에서 제거",
  prevent_email: "이메일을 사용자 이름으로 사용할 수 없습니다.",
  allow_noti: "알림을 허용하세요.",
  join_cap: "참여",
  pass_minimum: "**비밀번호는 소문자, 대문자, 숫자 및 특수 문자를 포함하여 12자 이상이어야 합니다.",
  pass_error: "비밀번호 요구사항을 확인하세요",
  people_that_like_article: "기사에 좋아요를 누른 사람들.",
  people_who_like_article: "귀하의 기사에 좋아요를 누른 사람들.",
  message_delete: "이 메시지는 삭제되었습니다.",
  message_edited: "수정됨",
  edit_message: "메시지 수정",
  edit_window_expired: "메시지는 전송 후 10분 이내에만 수정할 수 있습니다.",
  message_edit_save: "저장",
  copy: "복사",
  bookmark: "북마크",
  add_reaction: "반응 추가",
  delete_message: "메시지 삭제",
  more_options: "더보기",
  info: "정보",
  link_invite: "링크를 통해 초대",
  ll_nkk: "Kjuup에 초대",
  selected: "선택됨",
  is_active: "활성",
  inactive: "비활성",
  last_online: "마지막 접속 {{when}}",
  remove_user_l: "제거",
  link_expire: "생성된 각 링크는 72시간 동안 유효합니다.",
  company_language: "회사 언어",
  company_language_info: "언어 선택은 회사에 관한 모든 이메일 확인에 사용됩니다.",
  s_image: "이미지",
  m_image: "이미지",
  removeMsg: "탭하여 제거",
  block: '차단',
  unblock: '차단 해제',
  blocks: '정말로 이 사용자를 차단하시겠습니까?',
  unblocks: '정말로 이 사용자의 차단을 해제하시겠습니까?',
  bolcked_click_un_block: '이 연락처를 차단했습니다. 차단을 해제하려면 여기를 클릭하세요.',
  you_have_unblocked: '이 연락처의 차단을 해제했습니다.',
  you_have_blocked: '이 연락처를 차단했습니다.',
  unblock_to_send: '메시지를 보내려면 사용자 차단을 해제하세요.',
  pilot_text: "건설 주제 전문 AI",
  startup_screen_label: "시작 화면",
  startup_screen_info: "Kjuup 시작 시 열릴 화면을 선택하세요.",
  startup_screen_feed: "Home",
  startup_screen_messages: "메시지",
  startup_screen_saved: "시작 화면이 업데이트되었습니다",
email_on: "이메일 알림 채팅",
  email_on_grp: "이메일 알림",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "이 프로젝트의 이메일 알림을 활성화하거나 비활성화합니다. 이 옵션은 개인 설정에서 \"이메일 알림 채팅\"이 활성화된 경우에만 사용할 수 있습니다.",
  todo_notification_info: "새로운 할 일이 할당될 때마다 알림을 받게 됩니다.",
  info_val: "새 채팅 메시지를 짧은 시간 안에 읽지 않으면 이메일을 받게 됩니다. 각 프로젝트 설정이나 채팅 그룹 정보에서 특정 프로젝트 또는 채팅에 대해 이 기능을 끌 수 있습니다.",
  email_groups: "이 채팅에 대한 이메일 알림을 활성화하거나 비활성화합니다. 이 옵션은 개인 설정 및 프로젝트 설정에서 \"이메일 알림 채팅\"이 활성화된 경우에만 사용할 수 있습니다.",
  add_update_email: "이메일 추가/업데이트",
  text_to_verifiy: "\"이메일 알림 채팅\" 옵션은 파일에 확인된 이메일 주소가 있는 경우에만 활성화할 수 있습니다.",
  stored_email: "저장된 이메일: ",
  verify_email: "확인 대기 중!",
  join_call: "참여",
  call_is_started: "통화가 시작되었습니다",
  start_chat: "직접 채팅을 시작하시겠습니까?",
  project_rooms: "프로젝트",
  download_selected: "다운로드",
  add_employee_confirm: '정말로 이 사용자를 회사에 추가하시겠습니까?',
  invalid_deeplink: "유효하지 않은 deeplink URL. 필수 매개변수가 누락되었습니다.",
  deeplink_error: "deeplink를 처리할 수 없습니다. 나중에 다시 시도하세요.",
  reply: "답장",
  reply_enter: "답장 입력...",
  reply_sent_successfully: "답장이 성공적으로 전송되었습니다",
  reply_failed: "답장 전송 실패",
  reply_failed_generic: "답장 전송에 실패했습니다. 다시 시도하세요.",
  replying_to_message: "메시지에 답장 중",
  cancel_reply: "답장 취소",
  voice_message: "음성 메시지",
  send: "보내기",
  cancel: "취소",
  type_your_reply: "답장을 입력하세요...",
  suggested_replies: "제안된 답장",
  suggestions_error: "제안 로드 실패",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "잠시만요. 텍스트를 개별적으로 준비하고 있습니다.",
  loading_chat_message: "채팅 로딩 중...",
  extracting_message: "메시지 추출 중...",
  create_todo: "ToDo 만들기",
  create_todo_confirmation: "이 메시지에서 ToDo를 만들시겠습니까?",
  select_project_required: "프로젝트/그룹을 선택하세요",
  only_assigned_can_change_status: "할당된 사용자만 상태를 변경할 수 있습니다",
  todo_summary: "요약",
  todo_summary_placeholder: "todo 요약 입력...",
  todo_date: "날짜",
  todo_time: "시간",
  todo_date_hint: "원본 메시지 날짜/시간을 사용하려면 비워두세요",
  todo_created_success: "ToDo가 성공적으로 생성되었습니다",
  todo_creation_failed: "ToDo 생성 실패",
  create: "만들기",
  image: "이미지",
  images: "이미지",
  remove_all_images: "모든 이미지 제거",
  remove_image: "이미지 제거",
  remove_document: "문서 제거",
  remove_recording: "녹음 제거",
  play_recording: "녹음 재생",
  upload_image: "이미지 업로드",
  upload_document: "문서 업로드",
  record_audio: "오디오 녹음",
  stop_recording: "녹음 중지",
  stop_recording_text: "녹음 중지",
  please_remove_current_attachment: "현재 첨부 파일을 제거하세요",
  please_upload_image_file: "유효한 이미지 파일을 업로드하세요",
  please_upload_valid_document: "유효한 문서 파일을 업로드하세요",
  searching_messages: "메시지 검색 중...",
  loading_more: "더 로딩 중...",
  loading_more_users: "더 많은 사용자 로딩 중...",
  load_more_users: "더 많은 사용자 로드",
  no_more_users_to_load: "로드할 사용자가 더 이상 없습니다",
  no_messages_found: "메시지를 찾을 수 없습니다",
  try_different_keyword: "다른 키워드를 시도하거나 철자를 확인하세요.",
  search_messages: "메시지, 채팅 그룹, 프로젝트 및 사용자 검색...",
  todo: "ToDo",
  np_todo: "ToDo 없음",
  move_to_todo: "ToDo로 저장",
  remove_todo: "정말로 ToDo를 제거하시겠습니까?",
  remove_all_todo: "모든 ToDo 제거",
  remove_all_todo_confirm: "정말로 모든 ToDo를 제거하시겠습니까?",
  add_to_todo: "ToDo에 추가",
  remove_from_todo: "ToDo에서 제거",
  confirm: "확인",
  ok: "확인",
  read_more: "더 읽기",
  show_less: "접기",
  show_more: "더 보기",
  audio: "오디오",
  video: "비디오",
  notification_schedule: "알림 일정",
  notification_schedule_desc: "선택한 시간에만 푸시 및 이메일 알림을 받습니다. 그 시간 외에는 일시 중지됩니다.",
  learn_more: "자세히 알아보기",
  allow_notifications: "알림 허용:",
  every_day: "매일",
  weekdays: "평일 (월요일부터 금요일)",
  custom: "사용자 지정",
  monday: "월요일",
  tuesday: "화요일",
  wednesday: "수요일",
  thursday: "목요일",
  friday: "금요일",
  saturday: "토요일",
  sunday: "일요일",
  to: "까지",
  notification_settings: "알림",
  notification_settings_saved: "알림 설정이 성공적으로 저장되었습니다",
  notification_settings_error: "알림 설정 저장 실패",
  unavailability_note: "부재 알림",
  unavailability_description: "부재중 메모를 설정하세요. 활성화되면 메모가 모든 채팅에서 다른 사람들에게 표시되고 알림이 일시 중지됩니다.",
  unavailability_start_date: "시작일",
  unavailability_end_date: "종료일",
  unavailability_message: "메시지",
  unavailability_message_hint: "복귀 날짜의 자리 표시자로 {endDate}를 사용하세요.",
  unavailability_replacement: "대체 연락처",
  unavailability_replacement_placeholder: "긴급 요청을 위한 사용자 ID를 입력하세요",
  unavailability_replacement_current: "현재 대체자",
  unavailability_replacement_hint: "설정하면 긴급한 사안을 위해 이 사람에게 연락할 수 있는 링크가 부재 알림에 표시됩니다.",
  unavailability_replacement_none: "대체자 없음 (선택 사항)",
  unavailability_contact_urgent: "긴급 요청 시 연락처",
  unavailability_default_message: "현재 사무실에 없으며 Kjuup에 접속할 수 없습니다. {endDate}부터 다시 연락 가능하며, 그때 연락드리겠습니다.",
  unavailability_save: "저장",
  unavailability_deactivate: "비활성화",
  unavailability_active_until: "활성 기간",
  unavailability_saved: "부재 알림이 저장되었습니다",
  unavailability_save_error: "부재 알림 저장에 실패했습니다",
  unavailability_deactivated: "부재 알림이 비활성화되었습니다",
  unavailability_end_date_required: "종료일은 필수입니다",
  start_time_before_end_time: "시작 시간은 종료 시간보다 이전이어야 합니다",
  loading: "로딩 중",
  disabled: "비활성화됨",
  enable: "활성화",
  disable: "비활성화",
  forwarded: "전달됨",
  message_forwarded: "메시지가 전달되었습니다!",
  schedule_article_post: "기사 게시 일정",
  date: "날짜",
  time: "시간",
  scheduled_for_publication: "게시 예정",
  article_will_be_published_on: "기사가 다음에 게시됩니다:",
  reset_selection: "선택 재설정",
  continue: "계속",
  cancel: "취소",
  error_loading_members: "멤버 로딩 오류",
  please_fill_all_fields: "모든 필드를 입력하세요",
  invalid_email: "유효하지 않은 이메일 주소",
  member_added_successfully: "멤버가 성공적으로 추가되었습니다",
  error_onboarding_user: "사용자 추가 오류",
  error_creating_chat: "채팅 생성 오류",
  error_creating_group: "그룹 생성 오류",
  new_group: "새 그룹",
  please_select_or_enter_group_name: "그룹을 선택하거나 그룹 이름을 입력하세요",
  please_select_or_enter_room_name: "프로젝트를 선택하거나 프로젝트 이름을 입력하세요",
  error_creating_room: "프로젝트 생성 오류",
  error_opening_chat: "채팅 열기 오류",
  privacy_modal_text: "채팅에 프로젝트 관리자와 관련된 전문적인 콘텐츠가 없는 경우에만 \"비공개\"를 선택하세요.",
  not_private: "비공개 아님",
  private: "비공개",
  error_loading_groups: "그룹 로딩 오류",
  automatic_chat_export: "자동 채팅 내보내기",
  automatic_chat_export_info: "활성화 후 채팅 기록이 매월 지정된 이메일 주소로 자동 전송됩니다.",
  automatic_chat_export_no_email: "자동 채팅 내보내기를 활성화하려면 먼저 이메일 주소를 추가해야 합니다. 개인 설정에서 이메일 주소를 추가할 수 있습니다.",
  enter_email: "이메일 입력",
  update: "업데이트",
  confirm: "확인",
  export_to_email: "내보내기는 다음 이메일로 전송됩니다.",
  start_chat_button: "새 메시지",
  matching_existing_chats: "기존 채팅 일치",
  subject: "제목",
  add_subject: "제목 추가",
  chat_subject: "채팅 제목:",
  set_project_room: "프로젝트 설정",
  matching_existing_project_rooms: "기존 프로젝트 일치",
  name_project_room: "프로젝트 이름",
  professional_or_private: "전문가 또는 비공개",
  professional: "전문가",
  privacy_modal_text_updated: "채팅에 프로젝트 관리자와 관련된 전문적인 콘텐츠가 없는 경우에만 \"비공개\"를 선택하세요. 비공개 채팅은 프로젝트 관리자에게 표시되지 않습니다.",
  create_internal_chat: "외부 - 또는 내부 채팅?",
  internal_chat_description: "회사의 직원만 내부 채팅에 추가할 수 있습니다.",
  yes: "예",
  no: "아니오",
  chat_is_being_created: "채팅 생성 중...",
  discard_article_confirm: "이 글의 변경 사항을 정말 취소하시겠습니까?",
  please_enter_article_title: "먼저 기사 제목을 입력하세요.",
  please_add_mandatory_fields: "모든 필수 항목을 추가하세요",
  product_label: "제품:",
  no_companies_found: "회사를 찾을 수 없습니다",
  visible_to_all_followers: "모든 Kjuup 회원에게 표시",
  only_visible_to_employees: "직원에게만 표시",
  something_went_wrong: "문제가 발생했습니다. 다시 시도하세요",
  please_select_department: "부서/위치를 선택하세요",
  schedule: "일정",
  please_select_future_date_time: "기사를 일정하기 위해 미래의 날짜와 시간을 선택하세요.",
  please_select_different_date_time: "기사를 일정하기 위해 다른 날짜 또는 시간을 선택하세요.",
  please_select_later_time: "오늘 현재 시간보다 늦은 시간을 선택하세요.",
  unpin_article: "기사 고정 해제",
  pin_article: "기사 고정",
  and: "및",
  others: "기타",
  at: "에서",
  mute: "음소거",
  unmute: "음소거 해제",
  chat_muted_successfully: "채팅이 성공적으로 음소거되었습니다",
  chat_unmuted_successfully: "채팅 음소거가 성공적으로 해제되었습니다",
  mute_chat_confirm: "정말로 이 채팅을 음소거하시겠습니까? 새 메시지에 대한 알림을 더 이상 받지 않게 됩니다.",
  unmute_chat_confirm: "정말로 이 채팅의 음소거를 해제하시겠습니까? 새 메시지에 대한 알림을 다시 받게 됩니다.",
  please_select_group_to_forward: "메시지를 전달할 그룹을 선택하세요",
  record_not_found: "레코드를 찾을 수 없습니다!",
  please_select_position: "직책을 선택하세요",
  delete_article_confirm: "정말로 이 기사를 삭제하시겠습니까?",
  delete_company_service_confirm: "정말로 회사 서비스를 삭제하시겠습니까?",
  block_translation_confirm: "정말로 회사의 모든 멤버에 대한 프로젝트에서의 자동 번역을 차단하시겠습니까",
  unblock_translation_confirm: "정말로 회사의 모든 멤버에 대한 프로젝트에서의 자동 번역 차단을 해제하시겠습니까",
  please_select_file: "업로드할 파일을 선택하세요",
  role_in_building_industry: "건설 산업에서의 역할*",
  invalid_email_address: "유효하지 않은 이메일 주소",
  please_enter_password: "비밀번호를 입력하세요",
  password_change_email_sent: "Kjuup 이메일로 이메일이 발송되었습니다. 이메일의 확인 링크를 클릭하여 새 비밀번호를 확인해 주세요.",
  please_enter_username: "사용자 이름을 입력하세요",
  username_same_as_before: "사용자 이름은 이전과 동일할 수 없습니다",
  profile_deleted_successfully: "프로필이 성공적으로 삭제되었습니다",
  hardware_requirements: "하드웨어 요구사항",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU 속도 최소 2GHz<br/>• Windows 7 이상 / 모든 macOS 버전",
  submitting: "제출 중...",
  signing_in: "로그인 중...",
  please_enter_service_name: "서비스 이름을 입력하세요",
  something_went_wrong_error: "아! 문제가 발생했습니다...",
  something_went_wrong_try_again: "죄송합니다. 문제가 발생했습니다. 다시 시도하세요",
  position_label: "직책:",
  loading_room: "프로젝트 로딩 중...",
  navigating_to_room: "프로젝트로 이동 중",
  loading_chat: "채팅 로딩 중...",
  translate: "번역",
  show_original: "원문 표시",
  saving: "저장 중...",
  language_selection_info: "언어 선택은 회사와 관련된 모든 이메일 확인에 사용됩니다.",
  nav_call: "통화",
  nav_home: "홈",
  nav_messages: "메시지",
  nav_todo: "할 일",
  nav_rooms: "프로젝트",
  nav_all_rooms: "모든 프로젝트",
  pinned_rooms_max: "최대 10개의 프로젝트를 고정할 수 있습니다.",
  pinned_room_unpin: "고정 해제",
  pinned_rooms_drop: "빠른 선택을 위해 프로젝트를 여기로 끌어오세요",
  nav_profile: "프로필",
  nav_company: "회사",
  nav_company_documents: "문서",
  nav_logout: "로그아웃",
  add_member_title: "멤버 추가",
  continue_btn: "계속",
  search_placeholder: "검색",
  no_members_found: "멤버를 찾을 수 없습니다",
  no_groups_found: "그룹을 찾을 수 없습니다",
  no_rooms_found: "프로젝트를 찾을 수 없습니다",
  search_users_tab: "사용자",
  search_documents_tab: "문서",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "파일 없음",
  no_documents_available: "No documents",
  searching_users: "사용자 검색 중...",
  no_users_found: "사용자를 찾을 수 없습니다",
  search_emails_tab: "이메일",
  searching_emails: "이메일 검색 중...",
  no_emails_found: "이메일을 찾을 수 없습니다",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "이름 없는 그룹",
  unnamed_room: "이름 없는 프로젝트",
  all_members: "모두",
  room_label: "프로젝트:",
  subject_label: "제목:",
  no_members: "멤버 없음",
  creating_structure: "구조 생성 중",
  opening_chat: "채팅 열기 중",
  please_wait: "잠시 기다려주세요...",
  loading_todo: "ToDo 로딩 중...",
  task_updated: "작업이 업데이트되었습니다",
  error_updating_task: "작업 업데이트 오류",
  task_deleted: "작업이 삭제되었습니다",
  error_deleting_task: "작업 삭제 오류",
  delete_task_confirm: "정말로 이 작업을 삭제하시겠습니까?",
  description_label: "설명",
  description_placeholder: "설명 입력...",
  date_time_label: "날짜 및 시간",
  save_hint: "Ctrl+Enter로 저장, Esc로 취소",
  edit_label: "편집",
  delete_label: "삭제",
  todo_list_title: "할 일",
  tasks_count: "작업",
  search_placeholder_todo: "검색...",
  select_task_to_open_chat: "채팅을 열 작업 선택",
  today: "오늘",
  yesterday: "어제",
  time_suffix: "",
  from_chat: "소스 ToDo",
  assigned_to: "할당 대상",
  assign_users: "사용자 할당",
  no_users_assigned: "할당된 사용자 없음",
  assign: "할당",
  assign_to: "할당 대상...",
  navigate_to_chat: "채팅으로 이동",
  navigate_to_email: "이메일로 이동",
  show_original_message: "소스 표시",
  hide_original_message: "소스 숨기기",
  status_pending: "대기 중",
  status_in_progress: "진행 중",
  status_completed: "완료",
  show: "표시",
  close: "닫기",
  // Log translations
  status_confirmed: "[확인됨]",
  log_todo_created: "ToDo [생성됨]",
  log_todo_confirmed: "ToDo [확인됨]",
  log_todo_deleted: "ToDo [삭제됨]",
  log_todo_updated: "ToDo [업데이트됨]",
  log_description_updated: "[설명 업데이트됨]",
  log_deadline_updated: "[마감일 업데이트됨]",
  log_assigned_to: "[할당됨] {name}",
  log_unassigned_from: "[할당 해제됨] {name}",
  log_assignment_added: "[할당 추가됨]: {name}",
  log_assignment_removed: "[할당 제거됨]: {name}",
  log_status_updated: "[상태가] {from} [에서] {to} [로 변경됨]",
  log_status_changed: "[상태 변경됨]",
  log_status_changed_to: "[상태가 변경됨] {status}",
  log_changed_status_to: "[상태를 변경함]:",
  log_for_user: "[사용자]:",
  log_user_updated_status: "[사용자가 ToDo 상태를 업데이트함]",
  log_changed_date_to: "[날짜를 변경함]:",
  log_changed_description_to: "[설명을 변경함]:",
  log_moved_to: "[이동됨] {status}",
  todo_status_updated_from: "[에서]",
  todo_status_updated_to: "[로]",
  filter_pending: "대기 중",
  filter_confirmed: "확인됨",
  filter_assigned_to_me: "내 작업",
  filter_assigned_by_me: "위임됨",
  todo_project_label: "프로젝트:",
  assigned_users: "할당된 사용자:",
  todo_chat_label: "채팅:",
  history: "기록",
  todo_assigned_by: "할당자:",
  todo_assigned_push: "할당된 ToDo:",
  todo_assigned_push_empty: "새 ToDo가 할당되었습니다.",
  search_groups: "그룹",
  search_chat_groups: "채팅 그룹",
  search_project_room: "프로젝트",
  search_messages_tab: "메시지",
  searching_groups: "그룹 검색 중...",
  searching_rooms: "프로젝트 검색 중...",
  no_groups_found: "그룹을 찾을 수 없습니다",
  no_rooms_found: "프로젝트를 찾을 수 없습니다",
  create_poll: "투표",
  poll_question_label: "질문",
  poll_question_placeholder: "질문하기",
  poll_options_label: "선택지",
  poll_option: "선택지",
  poll_add_option: "선택지 추가",
  poll_allow_multiple: "여러 답변 허용",
  poll_multiple_allowed: "하나 이상 선택",
  poll_select_option: "하나 선택",
  poll_view_votes: "투표 보기",
  poll_vote_singular: "표",
  poll_vote_plural: "표",
  poll_votes: "투표 결과",
  poll_no_votes_yet: "아직 투표가 없습니다",
  transcript_step_processing: "텍스트 변환 중...",
  ai_transcript_tab: "AI-텍스트 변환",
  ai_transcript_info: "2026.03.09 이후에 생성된 음성 메시지에만 사용할 수 있습니다.",
  transcript_more: "...더 보기",
  transcript_less: "...접기",
  ki_transcript_voice_message: "KI-음성 메시지 트랜스크립트",
  ki_image_analysis: "AI 이미지 분석",
  type_message: "메시지를 입력하세요",
  email_tab_messages: "메시지",
  email_tab_email: "이메일",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "이메일 계정",
  email_connect_gmail: "Gmail 연결",
  email_connect_outlook: "Outlook 연결",
  email_no_accounts: "연결된 이메일 계정이 없습니다",
  email_no_accounts_hint: "프로필 설정에서 이메일 계정을 연결하세요",
  email_no_messages: "이메일이 없습니다",
  email_from: "보낸 사람",
  email_to: "받는 사람",
  email_subject: "제목",
  email_disconnect: "연결 해제",
  email_disconnect_confirm: "이 이메일 계정 연결을 해제하시겠습니까? 동기화된 모든 이메일이 삭제됩니다.",
  email_account_disconnected: "이메일 계정이 성공적으로 연결 해제되었습니다",
  email_account_disconnect_failed: "계정 연결 해제에 실패했습니다",
  email_connecting: "연결 중...",
  email_account_connected: "계정이 성공적으로 연결되었습니다",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "설정으로 이동",
  email_date: "날짜",
  email_reply: "답장",
  email_forward: "전달",
  email_copy_text: "텍스트 복사",
  email_text_copied: "복사되었습니다!",
  email_text_copy_failed: "텍스트를 복사할 수 없습니다.",
  email_delete: "삭제",
  email_not_spam: "스팸 아님",
  email_not_spam_success: "이메일이 받은편지함으로 이동되었습니다.",
  email_not_spam_failed: "받은편지함으로 이동하지 못했습니다.",
  email_delete_confirm: "이 이메일을 삭제하시겠습니까?",
  email_delete_from_folder: "{folder}에서 삭제하시겠습니까?",
  email_delete_permanent_from_folder:
    "{folder}에서 영구적으로 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.",
  email_save_draft_confirm: "이 이메일을 임시보관함에 저장하시겠습니까?",
  email_save_draft: "임시 저장",
  email_discard: "삭제",
  email_back_to_compose: "작성으로 돌아가기",
  email_draft_saved: "임시 저장되었습니다.",
  email_draft_save_failed: "임시 저장에 실패했습니다.",
  email_loading: "이메일 로딩 중...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "선택",
  email_attachment_singular: "첨부파일",
  email_attachment_plural: "첨부파일",
  email_back: "뒤로",
  email_download: "다운로드",
  email_close: "닫기",
  email_preview: "미리보기",
  email_preview_not_available: "미리보기를 사용할 수 없습니다",
  email_preview_failed: "미리보기를 사용할 수 없습니다",
  select_attachments: "첨부파일 선택",
  email_loading_preview: "미리보기 로딩 중...",
  email_mark_unread_failed: "개의 이메일을 읽지 않음으로 표시할 수 없습니다.",
  email_delete_failed: "개의 이메일을 삭제할 수 없습니다.",
  filter_all: "전체",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "직접 메시지",
  my_notes: "My Space",
  filter_internal_groups: "내부 그룹 채팅",
  filter_external_groups: "외부 그룹 채팅",
  filter_group_chats: "그룹 채팅",
  filter_groups_internal: "내부",
  filter_groups_external: "외부",
  filter_unread_only: "읽지 않은 항목만",
  room_daily_briefing_info: "활성화하면 개인 설정에 지정된 시각에 24시간마다 이 프로젝트의 보고서가 생성됩니다. 단, 해당 기간에 활동이 있는 경우에만 생성됩니다.",
  email_select_all: "모두 선택",
  email_deselect_all: "모두 선택 해제",
  email_reply_all: "전체 답장",
  email_reply_placeholder: "답장을 입력하세요...",
  email_forward_placeholder: "메시지를 추가하세요...",
  email_edit_draft: "초안 편집",
  email_attach: "첨부",
  email_attachment_from_original: "원본 메시지에서",
  email_remove: "제거",
  email_drop_files: "파일을 끌어다 놓아 첨부",
  email_loading_attachments: "첨부파일 로딩 중...",
  email_archive: "보관",
  mark_unread: "읽지 않음으로 표시",
  mark_read: "읽음으로 표시",
  email_all_accounts: "모든 계정",
  email_error: "오류",
  email_delete_email_failed: "이메일 삭제에 실패했습니다.",
  enter_url: "URL 입력",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: '지금 구독하기',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1개월 무료 체험',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: '오늘은 결제가 없습니다. 유료 구독이 시작되기 전에는 신용카드 정보를 요청하지 않습니다.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: '모든 이메일 계정을 Kjuup에서 바로 관리',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI가 답장을 작성 – 확인만 하면 됩니다',
  kjuup_io_feature_tasks: '할 일과 캘린더가 항상 자동으로 최신 상태 유지',
  kjuup_io_choose_plan: '플랜 선택',
  kjuup_io_plan_monthly: '월간',
  kjuup_io_plan_yearly: '연간',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Stripe로 안전하게 결제 · 언제든지 해지',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: '결제가 확인되었습니다. 구독을 활성화하는 중…',
  kjuup_io_toast_activating_soon: '결제가 확인되었습니다. 곧 구독이 활성화됩니다.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count}시간 남음',
  kjuup_io_trial_left_hour: '1시간 남음',
  kjuup_io_trial_left_minutes: '{count}분 남음',
  kjuup_io_trial_left_minute: '1분 남음',
  kjuup_io_trial_left_seconds: '{count}초 남음',
  kjuup_io_trial_left_second: '1초 남음',
  kjuup_io_trial_ending_now: '체험 기간이 곧 종료됩니다…',
  kjuup_io_request_timeout: '연결 시간이 초과되었습니다. 다시 시도해 주세요.',
  kjuup_io_info_days_free: '{days}일 완전 무료 – 체험 후에만 구독이 시작됩니다.',
  kjuup_io_discount_total: '할인: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: '개인: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: '닫기',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: '무료 체험이 종료되었습니다',
  kjuup_io_trial_ended_body: '이메일 및 기타 프리미엄 기능을 계속 사용하려면 Kjuup.io를 구독하세요.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: '무료 체험이 시작되었습니다',
  kjuup_io_toast_trial_fail: '무료 체험을 시작할 수 없습니다',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / 월',
  kjuup_io_save_amount_year: '연간 {price} 절약',
  kjuup_io_billed_annually_amount: '연간 청구 {price}',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: '제공 기능:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: '신용카드 불필요 – 결제 정보 없이 바로 시작하세요.',
  kjuup_io_info_cancel_anytime: '언제든지 해지 – 약정 없음, 위험 없음.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: '결제 주기',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: '결제 수단이 저장되었습니다. 체험 기간이 끝나면 요금이 청구됩니다.',
  calendar_sync_info: '모든 Kjuup ToDo를 캘린더와 자동으로 동기화합니다.',
  calendar_no_accounts: '아직 연결된 캘린더가 없습니다.',
  article_new_badge: '새 글',
  article_new_posts: '새 게시물 {0}개',
  documents: '문서',
  add_documents: '문서 추가',
  no_preview_available: '미리보기를 사용할 수 없습니다',
  no_preview_hint: '이 파일 형식은 미리 볼 수 없지만 전송은 정상적으로 됩니다.',
  max_documents_reached: '한 번에 최대 10개의 문서를 첨부할 수 있습니다.',
  open_file: '파일 열기',
  twofa_title: '2단계 인증',
  twofa_method_totp: '인증 앱',
  twofa_method_sms: '문자 메시지',
  twofa_method_email: '이메일',
  twofa_enter_app: '인증 앱의 6자리 코드를 입력하세요.',
  twofa_enter_sms: '문자로 보낸 6자리 코드를 입력하세요.',
  twofa_enter_email: '이메일로 보낸 6자리 코드를 입력하세요.',
  twofa_resend: '코드 다시 보내기',
  twofa_try_another: '다른 방법 시도',
  twofa_remember_device: '이 기기에서 30일 동안 다시 묻지 않기',
  twofa_sent: '코드를 보냈습니다.',
  twofa_invalid_code: '코드가 올바르지 않습니다. 다시 시도해 주세요.',
  twofa_something_wrong: '문제가 발생했습니다. 다시 시도해 주세요.',
  twofa_method_unavailable: '해당 확인 방법은 사용할 수 없습니다.',
  twofa_on_desc: '2단계 인증이 켜져 있습니다. 로그인할 때마다 코드가 필요합니다.',
  twofa_off_desc: '비밀번호 다음에 두 번째 단계를 추가하세요. 인증 앱이 가장 안전합니다.',
  twofa_methods: '방법',
  twofa_on: '켜짐',
  twofa_add: '추가',
  twofa_default_method: '기본 방법',
  twofa_default: '기본',
  twofa_turn_off: '끄기',
  twofa_disable_hint: '2단계 인증을 끄려면 비밀번호와 현재 코드를 입력하세요.',
  twofa_disable_need: '비밀번호와 확인 코드를 입력하세요.',
  twofa_code_placeholder: '6자리 코드 또는 백업 코드',
  twofa_send_code: '코드 보내기',
  twofa_primary_updated: '기본 확인 방법이 업데이트되었습니다.',
  twofa_disabled: '2단계 인증이 꺼졌습니다.',
  twofa_enabled: '2단계 인증이 켜졌습니다.',
  twofa_totp_help: 'Google Authenticator, Authy 또는 1Password로 이 QR 코드를 스캔하세요. 키를 직접 입력할 수도 있습니다.',
  twofa_secret_copied: '키를 복사했습니다',
  twofa_sms_help: '국제 형식으로 휴대폰 번호를 입력하세요. 6자리 코드를 문자로 보냅니다.',
  twofa_email_help: '계정 이메일로 6자리 코드를 보냅니다.',
  twofa_backup_title: '백업 코드',
  twofa_backup_help: '이 일회용 코드를 안전한 곳에 보관하세요. 휴대폰을 잃어버리면 각 코드는 한 번만 사용할 수 있습니다.',
  twofa_copy_codes: '코드 복사',
  twofa_codes_copied: '백업 코드를 복사했습니다',
  twofa_regenerate: '새 백업 코드 받기',
  twofa_regenerate_hint: '사용하지 않은 백업 코드가 교체됩니다. 비밀번호와 현재 코드를 입력하세요.',
  twofa_backup_remaining: '사용하지 않은 백업 코드 {n}개 남음',
  twofa_new_codes: '새 백업 코드',
  twofa_sms_unavailable: '문자 메시지 코드는 아직 사용할 수 없습니다.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "나에게 배정된 Kjuup 할 일은 Todoist의 Kjuup 프로젝트로 복사됩니다. Todoist에서 바꾼 내용은 다시 복사되지 않습니다.",
  todoist_connect: "Todoist 연결",
  todoist_connected: "Todoist가 연결되었습니다",
  todoist_connect_failed: "Todoist 연결에 실패했습니다",
  todoist_disconnect: "연결 해제",
  todoist_disconnected: "Todoist 연결이 해제되었습니다",
  todoist_disconnect_confirm: "Todoist 연결을 해제할까요? Todoist에 이미 있는 할 일은 남습니다. 동기화가 중지됩니다.",
  todoist_sync_now: "지금 동기화",
  todoist_syncing: "동기화 중…",
  todoist_sync_done: "동기화가 끝났습니다",
  todoist_sync_failed: "동기화에 실패했습니다",
  todoist_auth_error: "동기화를 계속하려면 Todoist를 다시 연결하세요.",
  todoist_last_sync: "마지막 동기화",
  todoist_not_connected: "Todoist가 연결되지 않았습니다",
  todoist_auth_url_failed: "Todoist 승인 페이지를 열 수 없습니다.",
  recommend_text: "Kjuup에 가입하고 늘 연결된 채로 커뮤니케이션을 깔끔하게 정리해 봐. 채널을 한곳에 모으고, 메시지는 알맞은 프로젝트에 두고, 매일 아침을 요약과 할 일로 시작해 – 모두 이미 쓰고 있는 앱과 동기화돼. 무료로 시작해 봐:",
  pro_auth_signin_title: '다시 오신 것을 환영합니다',
  pro_auth_signin_sub: '업무용 이메일로 로그인하세요.',
  pro_auth_email_or_username: '이메일 또는 사용자 이름',
  pro_auth_email_placeholder: 'name@company.de',
  pro_auth_forgot_password: '비밀번호를 잊으셨나요?',
  pro_auth_create_account: '계정 만들기',
  pro_auth_show_password: '비밀번호 표시',
  pro_auth_hide_password: '비밀번호 숨기기',
  pro_auth_register_sub: '이메일 확인 링크를 보내드립니다.',
  pro_auth_register_plus_sub: '사용자 이름과 비밀번호를 선택하세요. 다음 단계에서 보안 PIN을 설정합니다.',
  pro_auth_check_credentials: '이메일과 비밀번호를 확인하세요',
  pro_news_export_pdf: 'PDF로 내보내기',
  pro_news_pdf_failed: 'PDF를 생성할 수 없습니다.',
  pro_news_pdf_attachments: '첨부 파일',
  pro_news_pdf_video: '동영상',
  pro_auth_forgot_sub: '이메일을 입력하시면 비밀번호 재설정 링크를 보내드립니다.',
  pro_auth_send_link: '재설정 링크 보내기',
  pro_auth_plus_reset: 'PIN으로 재설정',
  pro_auth_show_pin: 'PIN 표시',
  pro_auth_hide_pin: 'PIN 숨기기',
  v2_auth_plus_only: 'Kjuup+ 전용',
  room_action_media: "파일",
  room_tab_overview: "개요",
  room_tab_history: "기록",
  chat_info_media: "파일",
  messages: "메시지",
  pro_todo_project_required: "프로젝트를 선택하세요",
  pro_todo_choose_project: "이 작업은 어느 프로젝트에 속하나요?",
  cockpit_report_delete_confirm: "이 일일 보고서를 삭제하시겠습니까?",
  cockpit_report_deleted: "일일 보고서가 삭제되었습니다",
  cockpit_tab_company: "회사",
  cockpit_bookmarked_priorities: "북마크한 작업",
  cockpit_load_error: "콕핏을 불러올 수 없습니다.",
  cockpit_retry: "다시 시도",
  cockpit_yesterday: "어제",
  cockpit_greeting_morning: "좋은 아침입니다",
  cockpit_greeting_day: "안녕하세요",
  cockpit_greeting_evening: "좋은 저녁입니다",
  cockpit_assistant_q_open: "오늘 남은 일은 무엇인가요?",
  cockpit_assistant_q_summarize: "채팅 {{room}} 요약",
  cockpit_assistant_q_overdue: "기한이 지난 작업은 무엇인가요?",
  cockpit_assistant_new: "새 항목 {{n}}개",
  cockpit_assistant_important: "중요 {{n}}개",
  cockpit_assistant_title: "Kjuup 어시스턴트",
  cockpit_assistant_hint: "탭하여 질문하기",
  room_overview_priority_no_detail: "보고서에 이 핵심 사항에 대한 자세한 내용이 없습니다.",
  room_overview_priority_from: "출처: {{name}}",
  room_overview_priority_open_task: "작업 열기",
  cockpit_priority_position: "우선순위 {{index}} / {{total}}",
  room_overview_today_title: "오늘 중요",
  room_overview_all_tasks: "전체",
  room_overview_tasks_empty: "열린 기한이나 작업이 없습니다",
  room_overview_appointments_empty: "예정된 일정이 없습니다",
  room_overview_no_priorities: "최신 보고서에 진행 중인 핵심 사항이 없습니다.",
  cockpit_report_top5: "핵심 사항 상위 5개",
  cockpit_report_todo_created: "작업이 생성되었습니다",
  cockpit_report_source_missing: "원본 메시지를 찾을 수 없습니다.",
  delete_bookmarked_priority_confirm: "이 북마크한 작업을 삭제하시겠습니까?",
  cockpit_report_create_todo: "작업 만들기",
  cockpit_priorities_deleting: "삭제 중 …",
  cockpit_priorities_select: "여러 개 삭제",
  cockpit_report_none: "항목이 없습니다.",
  cockpit_priorities_delete_confirm: "북마크한 작업 {count}개를 삭제하시겠습니까?",
  cockpit_priorities_delete_failed: "작업 {count}개를 삭제할 수 없습니다",
  cockpit_priorities_deleted: "작업 {count}개가 삭제되었습니다",
  cockpit_priorities_selected: "{count}개 선택됨",
  cockpit_channel_connected: "연결됨",
  cockpit_channel_not_connected: "연결 안 됨",
  cockpit_channel_connect: "연결",
  cockpit_channel_chat: "Kjuup 채팅",
  cockpit_channel_active: "활성",
  cockpit_channel_hidden: "숨김",
  cockpit_channel_enable: "사용",
  cockpit_channel_email: "이메일",
  cockpit_channel_check: "연결 확인",
  cockpit_channel_fix: "확인",
  cockpit_channel_forward: "전달 주소",
  cockpit_channel_not_set_up: "설정 안 됨",
  cockpit_channel_set_up: "설정",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "연결 끊김",
  cockpit_channel_importing: "가져오는 중",
  cockpit_channel_removing: "연결 해제 중",
  cockpit_channel_reconnect: "다시 연결",
  cockpit_channels_title: "채널",
  cockpit_company_role_super_admin: "회사 관리자",
  cockpit_company_role_dept_admin: "부서 관리자",
  cockpit_company_role_member: "직원",
  cockpit_company_none: "Kjuup+ 회사를 찾을 수 없습니다",
  cockpit_company_eyebrow: "회사",
  cockpit_company_inactive: "비활성",
  cockpit_company_settings: "회사 설정",
  cockpit_company_employees: "직원",
  cockpit_company_internal_rooms: "내부 프로젝트",
  cockpit_report_all_projects: "모든 프로젝트",
  cockpit_report_progress_emails: "이메일 분석 중",
  cockpit_report_progress_chats: "채팅 메시지 분석 중",
  cockpit_report_progress_documents: "첨부 파일 및 문서 분석 중",
  cockpit_report_progress_tasks: "작업 분석 중",
  cockpit_report_progress_summarizing: "콘텐츠 분석 중",
  cockpit_report_progress_reading: "이미 분석된 콘텐츠 재사용 중",
  cockpit_report_progress_collecting: "프로젝트의 이메일, 채팅, 작업 수집 중",
  cockpit_report_progress_priorities: "핵심 사항, 기한, 결정 사항 정리 중",
  cockpit_report_progress_queued: "보고서 준비 중",
  cockpit_report_creating_title: "일일 보고서를 준비하고 있습니다",
  cockpit_report_progress_count_one: "1개 항목 분석됨",
  cockpit_report_progress_count_many: "{{count}}개 항목 분석됨",
  cockpit_report_progress_hint: "보통 1~2분 걸리며, 그동안 콕핏을 계속 사용할 수 있습니다.",
  cockpit_report_time_hint: "일일 보고서는 가장 활발한 5개 프로젝트에 대해 매일 {{hour}}:00에 생성됩니다.",
  room_overview_priorities_title: "현재 상태 및 핵심 사항",
  room_overview_as_of: "{{time}} 기준",
  cockpit_report_delete: "일일 보고서 삭제",
  email_tag_daily_briefing: "일일 보고서",
  cockpit_report_unread: "새 항목",
  cockpit_report_clear_project: "모든 프로젝트 보기",
  cockpit_filter_project: "프로젝트",
  cockpit_filter_all_projects: "모든 프로젝트",
  cockpit_report_recreate: "일일 보고서 다시 만들기",
  cockpit_report_hide_previous: "이전 일일 보고서 숨기기",
  cockpit_report_show_previous: "이전 일일 보고서 보기",
  cockpit_report_room_empty: "이 프로젝트의 일일 보고서가 아직 없습니다",
  cockpit_report_empty: "일일 보고서가 아직 없습니다",
  cockpit_report_room_empty_hint: "이 프로젝트만을 위한 일일 보고서를 만듭니다.",
  cockpit_report_needs_mailbox: "Kjuup이 자동 작업이 포함된 일일 보고서를 만들 수 있도록 이메일 계정을 연결하세요.",
  cockpit_report_create: "일일 보고서 만들기",
  cockpit_email_connect: "이메일 연결",
  cockpit_email_none_title: "아직 연결된 이메일 계정이 없습니다",
  cockpit_email_none_reports: "메일함을 연결하면 Kjuup이 수신 이메일을 프로젝트에 배정하고 작업이 포함된 일일 보고서를 만들어 줍니다.",
  cockpit_email_none_client: "Gmail, Outlook 또는 IMAP을 연결하여 Kjuup.io에서 바로 이메일을 읽고, 배정하고, 답장하세요.",
  cockpit_email_reports_title: "현재 이메일 클라이언트",
  cockpit_email_reports_text: "Kjuup.io에 받은편지함 없음 · 프로젝트 {{rooms}}개에 {{hour}}:00 일일 보고서 · 수신 이메일은 프로젝트에 배정됩니다.",
  cockpit_email_reports_rooms: "프로젝트 관리",
  cockpit_email_settings: "이메일 설정",
  cockpit_email_error_title: "연결 확인",
  cockpit_email_client_title: "받은편지함 연결됨",
  cockpit_email_accounts_n: "계정 {{n}}개 연결됨",
  cockpit_email_last_sync: "마지막 동기화 {{when}}",
  cockpit_email_report_at: "일일 보고서 {{hour}}:00",
  cockpit_email_open_inbox: "받은편지함 열기",
  cockpit_email_eyebrow: "Kjuup 이메일",
  cockpit_email_accounts_label: "연결된 이메일 주소",
  email_folder_sent: "보낸 항목",
  email_no_subject: "(제목 없음)",
  cockpit_email_detail_loading: "이메일 불러오는 중 …",
  cockpit_email_detail_failed: "이메일을 불러올 수 없습니다.",
  cockpit_email_detail_empty: "이 이메일에는 본문이 없습니다.",
  cockpit_personal_settings: "개인 설정",
  cockpit_companies: "회사",
  cockpit_title: "콕핏",
  cockpit_back: "개요로 돌아가기",
  cockpit_day_overview: "오늘 하루 한눈에 보기",
  email_saved_to_project: "이메일이 프로젝트에 저장되었습니다",
  email_classify_need_project: "프로젝트 이름을 입력하세요",
  cockpit_email_deleted: "이메일이 삭제되었습니다",
  cockpit_email_sent_empty: "보낸 이메일이 아직 없습니다.",
  cockpit_email_incoming_empty: "받은 이메일이 아직 없습니다.",
  cockpit_email_incoming_title: "이메일",
  cockpit_email_incoming_sub: "수신 및 발신 이메일을 프로젝트에 배정하세요. 배정은 여기에서 조정할 수 있습니다.",
  cockpit_email_incoming_unassigned_n: "{{n}}개 미배정",
  cockpit_email_folder_inbox: "받은편지함",
  cockpit_email_folder_sent: "보낸편지함",
  cockpit_email_open: "이메일 열기",
  cockpit_email_incoming_suggested: "추천: {{room}}",
  cockpit_email_incoming_apply: "적용",
  cockpit_email_incoming_adjust: "배정 조정",
  cockpit_email_incoming_saving: "저장 중 …",
  cockpit_email_incoming_unassigned: "미배정",
  cockpit_email_incoming_show_less: "간단히 보기",
  cockpit_email_incoming_show_all: "{{n}}개 모두 보기",
  cockpit_io_settings: "Kjuup.io 설정",
  cockpit_io_settings_sub: "요금제 및 좌석, 직원 배정, 청구 및 인보이스.",
  products_coming_soon: "출시 예정",
  cockpit_upsell_io_title: "함께 생각하는 나의 오피스",
  cockpit_upsell_io_text: "이메일 계정을 Kjuup에 연결하세요. 이메일, 첨부 파일, 메시지는 해당 프로젝트에 자동 저장되며 원하면 자체 서버에도 보관할 수 있습니다. 매일 모든 콘텐츠의 핵심을 담은 전체 프로젝트 요약을 받고, 작업은 캘린더나 할 일 앱과 동기화됩니다.",
  cockpit_upsell_io_soon_title: "아직 예약할 수 없습니다",
  cockpit_upsell_io_soon_text: "Kjuup.io가 곧 출시됩니다. 지금 정보를 요청하세요. 예약이 가능해지면 알려 드리겠습니다.",
  cockpit_upsell_io_planned_price: "예정 가격",
  cockpit_upsell_io_cta_request: "정보 요청",
  kjuup_plus_abo_per_year: "/ 년",
  kjuup_plus_abo_per_month: "/ 월",
  kjuup_plus_abo_status_active: "활성",
  kjuup_plus_abo_status_requested: "해지 요청됨",
  kjuup_plus_abo_status_past_due: "결제 기한",
  kjuup_plus_abo_eyebrow: "Kjuup+ · 구독",
  kjuup_plus_abo_title: "Kjuup+ 패키지",
  kjuup_plus_abo_seats_free_one: "좌석 1개 남음",
  kjuup_plus_abo_billing: "청구",
  kjuup_plus_abo_yearly: "연간",
  kjuup_plus_abo_monthly: "월간",
  kjuup_plus_abo_amount: "금액",
  kjuup_plus_abo_ends: "종료일",
  kjuup_plus_abo_renews: "다음 갱신",
  kjuup_plus_abo_next_invoice: "다음 인보이스",
  kjuup_plus_abo_intro: "도입 가격",
  kjuup_plus_abo_pending_tier: "다음 갱신부터",
  kjuup_plus_abo_manual: "귀사의 Kjuup+는 개별 계약에 따라 활성화되어 있습니다.",
  kjuup_plus_abo_invoices: "인보이스",
  kjuup_plus_abo_invoice_paid: "결제 완료",
  kjuup_plus_abo_invoice_view: "보기",
  kjuup_plus_abo_invoices_less: "간단히 보기",
  kjuup_plus_abo_member_hint: "청구 및 해지는 회사 관리자가 관리합니다.",
  kjuup_plus_abo_withdraw: "요청 철회",
  kjuup_plus_abo_cancel_note: "사유(선택)",
  kjuup_plus_abo_cancel_send: "해지 요청",
  kjuup_plus_abo_cancel: "구독 해지",
  cockpit_upsell_plus_f1: "모든 직원의 커뮤니케이션 활동 관리",
  cockpit_upsell_plus_f2: "회사 내 특정 사용자 그룹에 알림",
  cockpit_upsell_plus_f3: "내부 그룹 채팅 저장",
  cockpit_upsell_plus_when_yearly: "연간 결제 시",
  cockpit_upsell_plus_size_small: "직원 1–50명",
  cockpit_upsell_plus_size_large: "직원 51–200명",
  cockpit_upsell_plus_title: "기업용 Kjuup+",
  cockpit_upsell_plus_text: "직원, 쓰기 권한, 회사 커뮤니케이션을 한곳에서 관리하세요. 내부 채널은 팀 내에 머물고, 외부 채널은 프로젝트 파트너와 연결하며, 특정 그룹에 직접 연락할 수 있습니다. Kjuup+에 더해 직원 그룹을 위한 Kjuup.io 이용권도 예약할 수 있습니다. Kjuup+와 Kjuup.io는 함께 사용할 수 있습니다.",
  cockpit_upsell_plus_size: "회사 규모",
  cockpit_upsell_plus_billing: "청구",
  cockpit_upsell_plus_per_company: "/ 회사 · 월, 부가세 별도",
  cockpit_upsell_plus_onboarding: "온보딩/도입 비용은 회사 규모에 따라 다릅니다",
  cockpit_upsell_plus_larger: "대규모 회사의 가격은 문의 바랍니다",
  cockpit_upsell_plus_cta: "부담 없이 문의하기",
  cockpit_kpi_deadlines_tasks: "기한 및 작업",
  cockpit_kpi_appointments: "일정",
  cockpit_room_admin: "프로젝트 및 채팅 관리",
  cockpit_room_admin_sub: "구성원, 미디어, 채팅이 포함된 모든 회사 프로젝트.",
  pro_todo_not_found: "이 작업은 더 이상 사용할 수 없습니다.",
  cockpit_chip_overdue: "기한 지남",
  cockpit_chip_today: "오늘",
  cockpit_calendar_week: "{{week}}주차",
  cockpit_prev_week: "이전 주",
  cockpit_next_week: "다음 주",
  cockpit_chip_requested: "요청됨",
  cockpit_todo_due: "기한 {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "{{name}} 요청",
  cockpit_todo_since: "{{when}}부터",
  cockpit_todo_no_date: "날짜 없음",
  cockpit_todo_mark_done: "완료로 표시",
  cockpit_my_tasks_title: "내 작업",
  cockpit_today_tasks_group: "오늘의 작업",
  cockpit_assign_none: "담당자 없음",
  no_project_found: "프로젝트를 찾을 수 없습니다",
  cockpit_row_more_actions: "추가 작업",
  needs_date: "날짜 지정",
  cockpit_assign_proposal: "{{name}}을(를) 인식했습니다. 배정할까요?",
  cockpit_assign_proposal_confirm: "배정",
  cockpit_assign_proposal_dismiss: "무시",
  cockpit_priority_date: "날짜",
  todo_calendar_add: "캘린더에 추가",
  todo_calendar_remove: "캘린더에서 제거",
  cockpit_todo_change_project: "프로젝트 변경",
  cockpit_todo_set_date: "날짜 설정",
  pro_todo_done_confirm: "이 작업을 완료로 표시하시겠습니까?",
  cockpit_task_delete_failed: "작업을 삭제할 수 없습니다.",
  cockpit_setup_title: "설정 완료",
  cockpit_setup_text: "채팅을 사용할지, Kjuup.io를 이메일 클라이언트로 사용할지 아니면 프로젝트와 일일 보고서에만 사용할지 선택하세요.",
  cockpit_setup_cta: "지금 설정",
  cockpit_group_tasks: "기한 및 작업",
  cockpit_group_appointments: "일정",
  cockpit_report_no_activity: "이 프로젝트에는 지난 24시간 동안 새 메시지나 이메일이 없습니다.",
  cockpit_report_room_unavailable: "이 프로젝트를 사용할 수 없습니다.",
  cockpit_report_create_failed: "일일 보고서를 만들 수 없습니다.",
  cockpit_report_created: "일일 보고서가 생성되었습니다",
  addon_enable_confirm: "애드온을 사용하시겠습니까?",
  addon_enable: "사용",
  addon_enabled: "애드온이 사용 설정되었습니다",
  nav_email: "이메일",
  nav_my_cockpit: "내 콕핏",
  nav_news: "뉴스",
  nav_recommend: "추천하기",
  pro_todo_status_done: "완료",
  pro_todo_status_open: "진행 중",
  v2_todo_remove: "제거",
  pro_todo_search_people: "사람 검색",
  pro_todo_clear: "지우기",
  pro_todo_assigned: "(배정됨)",
  pro_todo_no_people: "사람을 찾을 수 없습니다",
  pro_todo_search_rooms: "프로젝트 검색",
  pro_todo_no_rooms_match: "“{{q}}”와(과) 일치하는 프로젝트가 없습니다",
  pro_todo_no_rooms: "프로젝트를 찾을 수 없습니다",
  pro_todo_activity: "활동",
  pro_todo_show_less: "간단히 보기",
  pro_todo_show_all: "모두 보기({{n}})",
  pro_todo_due: "기한",
  pro_todo_room: "프로젝트",
  pro_todo_select_room: "프로젝트 선택",
  pro_todo_status: "상태",
  pro_todo_more: "더 보기",
  pro_todo_edit_title: "작업 편집",
  pro_todo_description: "설명",
  pro_todo_created_by: "작성자",
  pro_todo_chat: "채팅",
  navigate_to_source: "출처로 이동",
  todo_calendar_connect_title: "연결된 캘린더 없음",
  todo_calendar_connect_body_web: "캘린더 동기화 설정에서 캘린더를 연결하면 할 일을 추가할 수 있습니다.",
  todo_calendar_connect: "연결",
  todo_calendar_removed: "캘린더에서 제거되었습니다",
  todo_calendar_added_later: "추가되었습니다. 캘린더에 연결할 수 없어 Kjuup이 나중에 다시 시도합니다.",
  todo_calendar_added: "캘린더에 추가되었습니다",
  todo_calendar_no_date: "날짜가 있는 할 일만 캘린더에 추가할 수 있습니다.",
  todo_calendar_failed: "캘린더를 업데이트할 수 없습니다. 다시 시도해 주세요.",
  todo_calendar_date_title: "아직 날짜 없음",
  todo_calendar_date_save: "날짜 설정 및 추가",
  todo_calendar_date_body_web: "이 북마크한 작업에는 아직 날짜가 없습니다. 캘린더에 추가하려면 날짜를 설정하세요.",
  kjuup_io_setup_saved: "설정이 저장되었습니다",
  kjuup_io_setup_step: "단계",
  kjuup_io_setup_chats_title: "채팅을 사용하시겠습니까?",
  kjuup_io_setup_email_title: "이메일을 어디에서 읽으시겠습니까?",
  kjuup_io_setup_chats_sub: "동료 및 프로젝트 파트너와의 채팅은 선택 사항입니다. 콕핏에서 언제든지 표시하거나 숨길 수 있습니다.",
  kjuup_io_setup_email_sub: "Kjuup의 이메일 클라이언트를 사용할지, Outlook 등 현재 이메일 프로그램을 계속 사용할지만 선택합니다. 나중에 변경할 수 있습니다.",
  kjuup_io_setup_chats_yes: "예, 채팅 표시",
  kjuup_io_setup_chats_yes_text: "메시지에 채팅과 이메일이 포함됩니다. 프로젝트에는 모든 참여자를 위한 그룹 채팅이 있습니다.",
  kjuup_io_setup_chats_no: "아니요, 채팅 없이 사용",
  kjuup_io_setup_chats_no_text: "채팅이 숨겨집니다. \"메시지\"는 \"이메일\"이 되며 프로젝트, 작업, 일일 보고서는 그대로 유지됩니다.",
  kjuup_io_setup_email_client: "Kjuup의 이메일 클라이언트",
  kjuup_io_setup_email_client_text: "Kjuup에서 바로 이메일을 읽고 답장합니다.",
  kjuup_io_setup_email_reports: "현재 이메일 클라이언트",
  kjuup_io_setup_email_reports_text: "Outlook 등 현재 프로그램에서 계속 읽고 답장합니다.",
  kjuup_io_setup_skip: "나중에",
  next: "다음",
  kjuup_io_setup_finish: "설정 완료",
  today_label: "오늘",
  tomorrow_label: "내일",
  cockpit_todo_overdue: "기한 지남",
  cockpit_report_management_fazit: "경영진 요약",
  cockpit_todo_appointment: "일정",
  cockpit_todo_deadline: "기한",
  cockpit_todo_deadline_define: "기한 지정",
  pro_todo_status_acknowledged: "확인됨",
  pro_todo_responsible: "담당자",
  pro_todo_notice_confirmed: "채팅에서 확인됨",
  pro_todo_notice_sent_at: "메시지 전송됨",
  pro_todo_notice_again: "메시지 다시 보내기",
  pro_todo_notice_send: "Kjuup 메시지로 알리기",
  pro_todo_add_assignee: "추가",
  pro_todo_edit: "편집",
  pro_todo_change_room: "프로젝트 변경",
  pro_todo_due_on: "기한일",
  pro_todo_edit_due: "기한 편집",
  pro_todo_no_date: "날짜 없음",
  pro_todo_edit_description: "설명 편집",
  pro_todo_no_description: "아직 설명이 없습니다",
  pro_todo_title_label: "제목",
  pro_todo_title_placeholder: "제목 입력...",
  pro_todo_task: "작업",
  pro_todo_what: "무엇을 해야 하나요?",
  pro_todo_source_email: "이메일",
  pro_todo_sources: "출처",
  previous: "이전",
  kjuup_plus_abo_tier_large: "Kjuup+ Large(직원 최대 {max}명)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small(직원 최대 {max}명)",
  kjuup_plus_abo_status_ends: "{date}에 종료",
  kjuup_plus_abo_seats_over: "직원이 {max}명을 초과하면 – Kjuup에서 맞춤 견적을 안내해 드립니다.",
  kjuup_plus_abo_seats_next: "직원이 더 추가되면 패키지가 자동으로 {next}(으)로 전환됩니다(일할 계산).",
  kjuup_plus_abo_seats_used: "좌석 {total}개 중 {used}개 사용 중",
  kjuup_plus_abo_seats_free: "좌석 {count}개 남음",
  kjuup_plus_abo_intro_until: "{date}까지",
  kjuup_plus_abo_invoice_open: "미결제 · 기한 {date}",
  kjuup_plus_abo_invoices_all: "전체 {count}개 보기",
  kjuup_plus_abo_requested_hint: "{date}에 해지를 요청했습니다. Kjuup이 계약 기간 종료 시({end}) 확정합니다.",
  kjuup_plus_abo_cancel_hint: "Kjuup이 요청을 검토한 후 계약 기간 종료 시({end}) 해지를 확정합니다. 그때까지 Kjuup+는 계속 활성 상태입니다.",
  kjuup_plus_abo_withdrawn: "해지 요청이 철회되었습니다",
  kjuup_plus_abo_requested: "해지 요청됨",
  cockpit_upsell_plus_intro_hint: "처음 {months}개월, 이후 {price}",
  cockpit_upsell_plus_badge: "{months}개월 도입 특가",
  calendar_syncing: "캘린더에서 업데이트 중…",
  calendar_sync_up_to_date: "캘린더가 최신 상태입니다",
  calendar_sync_failed: "동기화 실패",
  delete_multiple_tasks_confirm: "정말로 {count}개의 ToDo를 삭제하시겠습니까?",
  todos_deleted_count: "{count}개의 ToDo가 삭제되었습니다",
  todos_deleted_partial: "{ok}개의 ToDo가 삭제됨, {fail}개 실패",
  todo_unknown: "알 수 없음",
  todo_created_from_message: "이 메시지로 작업을 만들었습니다",
  kjuup_io_todo_calendar_trial_ended_note: "캘린더 동기화 · 구독",
  kjuup_io_todo_calendar_nudge: "이 ToDo를 캘린더에 동기화하시겠습니까?",
  kjuup_io_todo_calendar_nudge_cta: "Kjuup.io 활성화",
  todo_confirmed: "할 일 확인됨",
  pro_todo_bulk_delete_title: "작업 {{n}}개를 삭제하시겠습니까?",
  pro_todo_previous_none_own: "기한이 지난 작업은 다른 사람이 할당한 것으로, 할당한 사람만 삭제할 수 있습니다.",
  pro_todo_previous_none: "기한이 지난 작업이 없습니다",
  pro_todo_previous_title: "기한이 지난 작업 {{n}}개를 삭제하시겠습니까?",
  pro_todo_previous_text: "지난 날짜의 미완료 작업이 모두 삭제됩니다.",
  pro_todo_previous_skipped: "다른 사람이 할당한 {{n}}개는 유지됩니다.",
  unassign_task_confirm: "이 작업에서 자신의 할당을 취소하시겠습니까?",
  unassign_label: "할당 취소",
  pro_todo_delete_title: "작업 삭제",
  pro_todo_today: "오늘",
  pro_todo_yesterday: "어제",
  pro_todo_since_yesterday: "어제부터",
  pro_todo_mark_open: "미완료로 표시",
  verify_completion: "확인",
  new_label: "새 항목",
  bookmarked_no_mylist: "북마크된 작업은 내 목록에 추가할 수 없습니다",
  delete_only_own: "직접 만든 작업만 삭제할 수 있습니다",
  todo_clear_all: "전체 삭제",
  pro_todo_of_completed: "{{total}}개 중 {{done}}개 완료",
  pro_todo_pick_date: "날짜 선택",
  pro_todo_show_day: "일 보기",
  todo_adjust_list: "목록 조정",
  pro_todo_section_upcoming: "예정",
  pro_todo_section_done: "완료",
  pro_todo_room_empty_today: "이 프로젝트에 오늘 작업이 없습니다",
  pro_todo_room_empty_day: "이 프로젝트에 이 날 작업이 없습니다",
  pro_todo_delete_previous: "모두 삭제",
  todo_my_list_empty: "오늘 일정이 비어 있습니다",
  todo_my_list_empty_hint: "작업을 추가하려면 “목록 조정”을 클릭하세요",
  pro_todo_empty_title: "항목 없음",
  pro_todo_empty_hint: "이 보기와 일치하는 작업이 없습니다.",
  pro_todo_selected: "{{n}}개 선택됨",
  delete_selected_count: "삭제 ({count})",
  pro_todo_adjust_done: "완료",
  pro_todo_deleting: "삭제 중…",
  pro_todo_reopen: "작업 다시 열기",
  pro_todo_step_done: "완료",
  move_back_in_progress: "진행 중으로 되돌리기",
  pro_todo_mark_not_started: "시작 안 함으로 표시",
  back_into_in_progress: "진행 중으로 되돌리기",
  pro_todo_mark_in_progress: "진행 중으로 표시",
  unassign_todo: "할 일 할당 취소",
  pro_todo_open_room: "프로젝트 열기",
  pro_todo_new_task: "새 작업",
  select_user_back_to_in_progress: "진행 중으로 되돌릴 사용자 선택",
  cockpit_email_accounts_n_many: "계정 {{n}}개 연결됨",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup 연락처",
  combined_tab_teams: "Teams 연락처",
  combined_bridge_failed: "Teams 사본을 만들 수 없습니다.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup 및 Teams 연락처: Microsoft Teams에도 표시되는 새 그룹이 만들어집니다.",
  teams_new_chat_title: "새 Teams 채팅",
  teams_new_chat_topic: "그룹 이름(선택 사항)",
  teams_new_chat_start: "채팅 시작",
  teams_new_chat_creating: "채팅을 만드는 중…",
  teams_new_chat_forbidden: "Microsoft Teams에서 이 채팅을 허용하지 않습니다(예: 조직 외부의 사람 또는 IT 부서의 정책).",
  teams_new_chat_too_many: "한 채팅에 사람이 너무 많습니다.",
  teams_new_chat_type_hint: "조직에서 검색하려면 이름을 입력하세요.",
  teams_new_chat_directory_forbidden: "조직에서 디렉터리 검색을 허용하지 않습니다. Teams 채팅의 사람만 표시됩니다.",
  teams_new_chat_account: "계정",
};
